module.exports = __webpack_public_path__ + "img/table.c5d2333b.png";